<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">Share report</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <div class="bs-stepper wizard-numbered mt-2">
      <div class="bs-stepper-header">
        <div
          class="step"
          [ngClass]="{ crossed: activeTab !== 1, active: activeTab === 1 }"
          (click)="setActiveTab(1)"
        >
          <button type="button" class="step-trigger">
            <span class="bs-stepper-label">
              <i [class]="teamIcn"></i>
              <span class="bs-stepper-title">Teams</span>
            </span>
          </button>
        </div>
        <div
          class="step"
          [ngClass]="{ crossed: activeTab !== 2, active: activeTab === 2 }"
          (click)="setActiveTab(2)"
        >
          <button type="button" class="step-trigger">
            <span class="bs-stepper-label">
              <i [class]="memberIcn"></i>
              <span class="bs-stepper-title">Members</span>
            </span>
          </button>
        </div>
        <div
          class="step"
          [ngClass]="{ crossed: activeTab !== 3, active: activeTab === 3 }"
          (click)="setActiveTab(3)"
        >
          <button type="button" class="step-trigger">
            <span class="bs-stepper-label">
              <i [class]="emailIcn"></i>
              <span class="bs-stepper-title">Others</span>
            </span>
          </button>
        </div>
      </div>
      <div class="bs-stepper-content">
        <div
          class="clear-buttons d-flex justify-content-end"
          *ngIf="
            selectedItems.length &&
            !(selectedItems.length === 1 && selectedItems[0].type === ShareReportUserType.Self)
          "
        >
          <button (click)="clearAllByType()" class="clear-btn">Clear all</button>
        </div>

        <div
          #selectedContainer
          class="selected-container"
          *ngIf="
            selectedItems.length &&
            !(selectedItems.length === 1 && selectedItems[0].type === ShareReportUserType.Self)
          "
        >
          <div *ngFor="let selectedItem of selectedItems">
            <div
              *ngIf="selectedItem.type !== ShareReportUserType.Self"
              class="selected-item d-flex justify-content-between align-items-center"
              [ngClass]="{
                'member-item': selectedItem.type === ShareReportUserType.Teams,
                'team-item': selectedItem.type === ShareReportUserType.Members,
                'self-item': selectedItem.type === ShareReportUserType.Others
              }"
            >
              <i
                [class]="
                  selectedItem.type === ShareReportUserType.Teams
                    ? teamIcn
                    : selectedItem.type === ShareReportUserType.Members
                    ? memberIcn
                    : emailIcn
                "
              ></i>
              <span>{{ selectedItem.name }}</span>
              <button
                class="remove-btn"
                (click)="removeFromSelected(selectedItem.id, selectedItem.type)"
              >
                ×
              </button>
            </div>
          </div>
        </div>

        <div id="personal-info" class="content" *ngIf="activeTab === 1">
          <div class="content-header mb-4"></div>
          <div class="g-6">
            <div class="">
              <div class="card-heading is-bordered">
                <input
                  type="text"
                  [(ngModel)]="searchTermTeams"
                  placeholder="Search teams..."
                  (input)="filterTeams()"
                  class="search-input"
                />
              </div>
              <div class="card-body no-padding">
                <div class="tree-view">
                  <!-- Show loader if loading, otherwise show teams list or no teams message -->
                  <ng-container *ngIf="isInlineLoader; else teamsListContainer">
                    <ng-container
                      *ngTemplateOutlet="commonLoader; context: { message: teamLoadingMessage }"
                    ></ng-container>
                  </ng-container>

                  <ng-template #teamsListContainer>
                    <div class="users-list" *ngIf="filteredTeams.length > 0; else noTeamsFound">
                      <div *ngFor="let node of filteredTeams" class="tree-row">
                        <div class="node parent-node">
                          <input
                            type="checkbox"
                            [checked]="node.checked"
                            class="chkOverview projectScopeChecks"
                            (change)="onSelectionChanged(node, ShareReportUserType.Teams)"
                          />
                          <span class="node-name" (click)="toggleExpand(node)">
                            <span class="toggle-icon">
                              <ng-container *ngIf="node.expanded">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="#9d52fe"
                                  class="bi bi-caret-down-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                                  />
                                </svg>
                              </ng-container>
                              <ng-container *ngIf="!node.expanded">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="#9d52fe"
                                  class="bi bi-caret-right-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"
                                  />
                                </svg>
                              </ng-container>
                            </span>
                            {{ node.name }}
                            <span class="count-lbl">({{ node.members.length }} Members)</span>
                          </span>
                        </div>
                        <div
                          [ngClass]="{ expanded: node.expanded, collapsed: !node.expanded }"
                          class="child-container"
                        >
                          <div *ngIf="node.members.length > 0">
                            <div *ngFor="let child of node.members" class="tree-row child-row">
                              <div class="node child-node">
                                <span class="node-name">{{ child.name }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="social-links" class="content" *ngIf="activeTab === 2">
          <div class="content-header mb-4"></div>
          <div class="g-6">
            <div class="text-black">
              <div class="card-heading is-bordered">
                <input
                  type="text"
                  [(ngModel)]="searchTermMembers"
                  placeholder="Search members..."
                  (input)="filterMembers()"
                  class="search-input"
                />
              </div>
              <div class="card-body no-padding">
                <!-- Show loader if loading, otherwise show members list or no members message -->
                <ng-container *ngIf="isInlineLoader; else membersListContainer">
                  <ng-container
                    *ngTemplateOutlet="commonLoader; context: { message: memberLoadingMessage }"
                  ></ng-container>
                </ng-container>

                <ng-template #membersListContainer>
                  <div *ngIf="filteredMembers.length > 0; else noMembersFound">
                    <div class="users-list">
                      <div *ngFor="let node of filteredMembers" class="tree-row">
                        <div class="node parent-node">
                          <input
                            type="checkbox"
                            [checked]="node.checked"
                            class="chkOverview projectScopeChecks"
                            [disabled]="node.disabled"
                            (change)="onSelectionChanged(node, ShareReportUserType.Members)"
                          />
                          <span class="node-name" (click)="toggleExpand(node)">
                            {{ node.name }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>

        <div id="custom-mail" class="content" *ngIf="activeTab === 3">
          <div class="content-header mb-4"></div>
          <div class="g-6">
            <div class="">
              <div class="card-heading is-bordered">
                <small class="text-muted">
                  Enter email addresses one at a time and press Enter or click the + button to add
                  them.
                </small>
              </div>
              <div class="card-body no-padding users-list">
                <div class="email-input-container">
                  <input
                    type="email"
                    [(ngModel)]="newEmail"
                    placeholder="Enter your email and press Enter"
                    class="search-input-with-button mt-2 mb-1"
                    (keydown.enter)="addEmailToSelectedItems()"
                    (ngModelChange)="checkValidation()"
                  />
                  <button
                    *ngIf="!emailError && newEmail.trim()"
                    class="add-email-btn"
                    (click)="addEmailToSelectedItems()"
                    type="button"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                      />
                    </svg>
                  </button>
                </div>
                <div *ngIf="emailError" class="input-error mb-2 mt-0">
                  <div *ngIf="emailError == 'required'">Please enter your email address.</div>
                  <div *ngIf="emailError == 'pattern'">Please enter a valid email address.</div>
                  <div *ngIf="emailError == 'duplicate'">
                    This email has been added already. Please use a different one.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="card-body no-padding users-list">
            <div>
              <div class="add-friend-block align-items-center transition-block d-flex pt-4">
                <input
                  type="checkbox"
                  [checked]="self?.checked"
                  (change)="onSelectionChange(self, self.type)"
                  class="chkOverview projectScopeChecks"
                />
                <div class="include-lbl">
                  <span>Include myself</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
      <button
        type="button"
        [disabled]="!selectedItems.length"
        class="modelBtn"
        (click)="sendMail()"
      >
        Send
      </button>
    </div>
  </div>
</div>

<!-- Common Loader Template -->
<ng-template #commonLoader let-message="message">
  <piqet-angular-inline-loader [message]="message"> </piqet-angular-inline-loader>
</ng-template>

<!-- Teams Templates -->
<ng-template #noTeamsFound>
  <div class="no-data-message">
    <div>No teams found</div>
  </div>
</ng-template>

<!-- Members Templates -->
<ng-template #noMembersFound>
  <div class="no-data-message">
    <div>No members found</div>
  </div>
</ng-template>
